export const USER_JOINED = 'vnc:joined'
export const USER_EDIT = 'vnc:edit'
export const USER_READONLY = 'vnc:readonly'
export const SESSION_ENDED = 'vnc:close'
export const CHANNEL_REFRESH = 'channel:refresh'

interface ChannelRefreshAction {
	type: typeof CHANNEL_REFRESH
	sender: string
}

interface VncJoinedAction {
	type: typeof USER_JOINED
	channelId: string
	sender: string
	payload: { name: string }
}

interface VncEditAction {
	type: typeof USER_EDIT
	channelId: string
	sender: string
	payload: { userId: string; channelId: string }
}

interface VncReadonlyAction {
	type: typeof USER_READONLY
	channelId: string
	sender: string
	payload: { userId: string; channelId: string }
}

interface sessionEndedAction {
	type: typeof SESSION_ENDED
	channelId: string
	sender: string
}

export type UserMessagingActionTypes = VncJoinedAction | VncEditAction | VncReadonlyAction | sessionEndedAction | ChannelRefreshAction
